import React, { createContext, useState, useContext, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true); // 🔑 CLAVE

  useEffect(() => {
    try {
      const usuarioGuardado = localStorage.getItem("usuario");
      const padreGuardado = localStorage.getItem("padre");

      if (usuarioGuardado) {
        setUsuario(JSON.parse(usuarioGuardado));
      } else if (padreGuardado) {
        setUsuario(JSON.parse(padreGuardado));
      }
    } catch (error) {
      console.error("Error cargando sesión:", error);
      setUsuario(null);
    } finally {
      setLoading(false); // ✅ SOLO UNA VEZ
    }
  }, []);

  return (
    <AuthContext.Provider value={{ usuario, setUsuario, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth debe usarse dentro de AuthProvider");
  }
  return context;
};
